export default function (date) {
  // Content dates must render identically on local machines and UTC build servers.
  const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
  return new Date(date).toLocaleDateString('en', options);
}
